import { FC, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDebounce } from 'shared/lib';

interface IProps {
  setReplicaNameFilter: (value: string) => void;
}

export const AvatarSearchInput: FC<IProps> = ({ setReplicaNameFilter }) => {
  const [nameInputValue, setNameInputValue] = useState('');
  const changeFilterNameValue = useDebounce(setReplicaNameFilter, 500);
  return (
    <div className={'ag-relative ag-overflow-hidden'}>
      <IoSearchOutline
        size={20}
        className={
          'ag-absolute ag-text-neutral-500 ag-left-3 ag-top-1/2 ag-transform -ag-translate-y-1/2'
        }
      />
      <input
        className="ag-rounded-md ag-py-2 ag-pl-10 ag-pr-3 ag-border-neutral-300 ag-h-10 ag-outline-none ag-ring-0 focus:ag-ring-0 focus:ag-outline-none focus:ag-border-primary-800 ag-mr-2 ag-w-full"
        type="text"
        value={nameInputValue}
        onChange={(e) => {
          setNameInputValue(e.target.value);
          changeFilterNameValue(e.target.value);
        }}
        placeholder={'Avatar name'}
      />
    </div>
  );
};
